import { useAtomValue } from 'jotai';
import { domain } from 'modules/data';
import {
    useGetNetSuiteExpensesMatchingSuggestions,
    useGetNetSuiteItemsMatchingSuggestions,
} from 'shared/data/webApp/v2';
import { netSuiteBillFieldValuesState } from 'shared/states';

import { NetSuiteMatchingSuggestionsParams } from './useNetSuiteMatchingSuggestions.types';

export const useNetSuiteMatchingSuggestions = ({
    request,
    lineType,
    lineNumber,
    accountId,
    categoryId,
    itemId,
    isEnabled = true,
}: NetSuiteMatchingSuggestionsParams) => {
    const billFieldValues = useAtomValue(netSuiteBillFieldValuesState);

    const { data: netSuiteItemsMatchingSuggestions, isFetching: isFetchingNetSuiteItemsMatchingSuggestions } =
        useGetNetSuiteItemsMatchingSuggestions(
            {
                path: {
                    companyId: request.companyId,
                },
                query: {
                    itemId,
                    vendorBillRequestId: request.id,
                    vendorBillLineNumber: lineNumber,
                    vendorId: billFieldValues.vendor?.id,
                    currencyId: billFieldValues.currency?.id,
                },
            },
            { enabled: isEnabled && lineType === domain.NetSuiteMatchingLineType.Item }
        );

    const { data: netSuiteExpensesMatchingSuggestions, isFetching: isFetchingNetSuiteExpensesMatchingSuggestions } =
        useGetNetSuiteExpensesMatchingSuggestions(
            {
                path: {
                    companyId: request.companyId,
                },
                query: {
                    accountId,
                    categoryId,
                    vendorBillRequestId: request.id,
                    vendorBillLineNumber: lineNumber,
                    vendorId: billFieldValues.vendor?.id,
                    currencyId: billFieldValues.currency?.id,
                },
            },
            { enabled: isEnabled && lineType === domain.NetSuiteMatchingLineType.Expense }
        );

    return {
        suggestions: netSuiteItemsMatchingSuggestions || netSuiteExpensesMatchingSuggestions,
        isFetching: isFetchingNetSuiteItemsMatchingSuggestions || isFetchingNetSuiteExpensesMatchingSuggestions,
    };
};
